import { Component, Input } from '@angular/core';
import {
  ComponentRendering,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';
import { NgClass } from '@angular/common';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { GenericLinkDirective } from '@core/jss-utils';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';

import { JumbotronHeight } from '../../../jumbotron/jumbotron-settings.model';
import type { HeaderSize } from '../../basic-content-settings.model';
import { BasicContentVariantInheritableComponent } from '../basic-content-variant.inheritable.component';
import { BasicContentPartialHeadingComponent } from '../../partials/basic-content-partial-heading/basic-content-partial-heading.component';
import { TimerWidgetWrapperComponent } from '../../../timer/timer-widget/timer-widget-wrapper/timer-widget-wrapper.component';

@Component({
  selector: 'wl-basic-content-variant-jumbotron',
  templateUrl: './basic-content-variant-jumbotron.component.html',
  styleUrls: [
    './basic-content-variant-jumbotron.component.ed.scss',
    './basic-content-variant-jumbotron.component.essent.scss',
  ],
  standalone: true,
  imports: [
    NgClass,
    BasicContentPartialHeadingComponent,
    JssModule,
    TimerWidgetWrapperComponent,
    RichTextWrapperComponent,
    GenericLinkDirective,
    TrackImpressionDirective,
    TrackLinkDirective,
  ],
})
export class BasicContentVariantJumbotronComponent extends BasicContentVariantInheritableComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) rendering!: ComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public showMarketingHeader = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public height: JumbotronHeight = 'xsmall';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() timerWidgetShown = false;

  private readonly heightToHeadingSize: {
    [height in JumbotronHeight]: HeaderSize;
  } = {
    large: 'h1',
    medium: 'h2',
    small: 'h3',
    xsmall: 'h4',
  };

  private readonly heightToSubheadingSize: {
    [height in JumbotronHeight]: HeaderSize;
  } = {
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
  };

  override get headingSize(): HeaderSize {
    return this.heightToHeadingSize[this.height] ?? 'h1';
  }

  override get subheadingSize(): HeaderSize {
    return this.heightToSubheadingSize[this.height] ?? 'h2';
  }

  get isSmall(): boolean {
    return this.height === 'small' || this.height === 'xsmall';
  }

  get hasButtons() {
    return (
      this.content?.buttons?.primary?.link?.href ||
      this.content?.buttons?.secondary?.link?.href
    );
  }
}
